import { types } from 'mobx-state-tree'
import { ROLES } from 'constants/account.roles'

import { extendMember } from './core'
import { Wallet } from './wallet'

const Address = types.model({
  address1: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  country: '',
})

export const User = extendMember(
  types
    .model('User', {
      id: types.identifierNumber,
      email: types.string,
      firstName: types.maybeNull(types.string),
      lastName: types.maybeNull(types.string),
      nickName: types.maybeNull(types.string),
      role: types.enumeration('Roles', [ROLES.USER, ROLES.ADMIN]),
      wallet: types.optional(Wallet, { balance: 0 }),
      address: types.optional(Address, {}),
      taxId: types.maybeNull(types.string),
    })
    .views((self) => ({
      get fullName() {
        if (self.firstName && self.lastName) {
          return `${self.firstName} ${self.lastName}`
        }

        return self.firstName ? self.firstName : self.lastName
      },

      get displayName() {
        return self.nickName || self.fullName || self.email
      },
    })),
  {
    type: ROLES.USER,
  }
)
